import { type TableColumnSpec } from "#blocks/Table/buildTableColumns"
import { ProjectForTable } from "#customTypes/composedTypes/projectTypes"
import { toSortableNumber } from "#utils/sortHelpers"

export const PROJECT_TABLE_COLUMNS: TableColumnSpec[] = [
  { key: "name", width: 200 },
  { key: "semester", width: 120 },
  { key: "daysToComplete", width: 130, align: "right" },
  { key: "medium", width: 130 },
  { key: "skillLevels", width: 200 },
  { key: "notes", width: 200 },
  { key: "description", width: 200 },
  { key: "lastUpdatedAt", width: 140, title: "Last Updated" },
]

export const PROJECT_SEARCHABLE_FIELDS: (keyof ProjectForTable)[] = [
  "name",
  "medium",
  "skillLevels",
  "description",
  "notes",
] as const

export const PROJECT_SORTABLE_FIELDS = [
  "name",
  "semester",
  "daysToComplete",
  "medium",
  "skillLevels",
  "lastUpdatedAt",
] as const

// daysToComplete is stored as a string number; sort it numerically.
// Shared by useTableSort + buildTableColumns.
export const getProjectSortValue = (
  row: ProjectForTable,
  field: string
): string | number => {
  if (field === "daysToComplete") return toSortableNumber(row.daysToComplete)
  const value = row[field]
  return typeof value === "number" ? value : String(value ?? "")
}

export const PROJECT_MEDIA = {
  ACADEMIC_DRAWING: "Academic Drawing",
  ACRYLIC: "Acrylic",
  CLAY: "Clay",
  COMIC: "Comic",
  CREATIVE_DRAWING: "Creative Drawing",
  DIGITAL: "Digital",
  WATERCOLOR: "Watercolor",
}

export const PROJECT_MEDIA_OPTIONS = [
  {
    label: "Academic drawing",
    value: PROJECT_MEDIA.ACADEMIC_DRAWING,
  },
  {
    label: "Acrylic",
    value: PROJECT_MEDIA.ACRYLIC,
  },
  {
    label: "Clay",
    value: PROJECT_MEDIA.CLAY,
  },
  {
    label: "Comic",
    value: PROJECT_MEDIA.COMIC,
  },
  {
    label: "Creative drawing",
    value: PROJECT_MEDIA.CREATIVE_DRAWING,
  },
  {
    label: "Digital",
    value: PROJECT_MEDIA.DIGITAL,
  },
  {
    label: "Watercolor",
    value: PROJECT_MEDIA.WATERCOLOR,
  },
]
